// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"631":"5b718f91","9249":"94a1c407"}[chunkId] + ".css";
};